module.exports = __webpack_public_path__ + "images/category_lp/retro_game/assessment_achievements/6@2x_16b70e258a581101d927fd7b443d533a.png";